<template>
  <div class="layout">
    <!-- 现代化导航栏 -->
    <nav class="modern-navbar">
      <div class="navbar-container">
        <!-- 品牌Logo -->
        <div class="navbar-brand">
          <span class="brand-text">飞行学院</span>
        </div>

        <!-- 移动端菜单按钮 -->
        <button class="mobile-menu-btn" @click="toggleMobileMenu" :class="{ active: mobileMenuOpen }">
          <span></span>
          <span></span>
          <span></span>
        </button>

        <!-- 导航菜单 -->
        <div class="navbar-menu" :class="{ active: mobileMenuOpen }">
          <ul class="nav-links">
            <li class="nav-item" v-for="item in navItems" :key="item.path">
              <a
                class="nav-link"
                :class="{ active: current === item.path }"
                @click="navigateTo(item.path)"
              >
                <i :class="item.icon"></i>
                <span>{{ item.label }}</span>
              </a>
            </li>
          </ul>

          <!-- 用户菜单 -->
          <div class="user-menu">
            <div class="user-dropdown" @click="toggleUserMenu" :class="{ active: userMenuOpen }">
              <div class="user-avatar">
                <i class="user-icon">👤</i>
              </div>
              <span class="user-name">{{ userName }}</span>
              <i class="dropdown-arrow">▼</i>
            </div>
            <div class="dropdown-menu" :class="{ show: userMenuOpen }">
              <a class="dropdown-item" @click="logout">
                <i class="logout-icon"></i>
                <span>退出登录</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>

    <div class="main-content mt-3">
      <div class="container">
        <router-view />
      </div>
    </div>

    <footer class="text-center py-3 bg-light">
      © Copyright 飞行学员作风纪律养成和行为规范管理系统 All Rights Reserved.
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userName: '',
      current: '', // 用于标识当前激活的导航项
      username: localStorage.user_id,
      showAdmin: false,
      role_type: localStorage.role_type,
      mobileMenuOpen: false,
      userMenuOpen: false,
      navItems: [
        { path: '/grade_record', label: '成绩记录', icon: '📊' },
        { path: '/score_record', label: '扣分记录', icon: '📝' },
        { path: '/apply_record', label: '加分申请', icon: '📋' },
        { path: '/bonus_apply', label: '综合素质分申请', icon: '⭐' },
        { path: '/bonus_records', label: '综合素质分记录', icon: '📈' },
        { path: '/weekly_report', label: '周报管理', icon: '📅' },
        { path: '/monthly_report', label: '月报上传', icon: '📄' },
        { path: '/data_query', label: '数据查询', icon: '🔍' },
        { path: '/password_change', label: '密码修改', icon: '🔐' }
      ]
    };
  },
  mounted() {
    this.loadUserName();
    this.initCurrentRoute();

    if (!localStorage.token) {
      this.$message.warning("请先登录！");
      this.$router.push('/login');
    }

    // 点击外部关闭菜单
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
  methods: {
    loadUserName() {
      const name = localStorage.getItem("name");
      this.userName = name ? name : "Guest";
    },
    initCurrentRoute() {
      this.current = this.$route.path;
    },
    navigateTo(route) {
      this.current = route;
      this.$router.push(route);
      this.mobileMenuOpen = false; // 导航后关闭移动端菜单
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
      this.userMenuOpen = false; // 关闭用户菜单
    },
    toggleUserMenu() {
      this.userMenuOpen = !this.userMenuOpen;
    },
    handleOutsideClick(event) {
      // 检查点击是否在导航栏外部
      if (!event.target.closest('.modern-navbar')) {
        this.mobileMenuOpen = false;
        this.userMenuOpen = false;
      }
    },
    logout() {
      localStorage.clear();
      this.$router.push({ path: '/login' });
    },
  },
  watch: {
    $route(to) {
      this.current = to.path;
    }
  }
};
</script>

<style scoped>
/* 现代化导航栏样式 */
.modern-navbar {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
  backdrop-filter: blur(10px);
}

.navbar-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  min-width: 0;
}

/* 品牌Logo */
.navbar-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: transform 0.3s ease;
  flex-shrink: 0;
}

.navbar-brand:hover {
  transform: scale(1.05);
}

.brand-icon {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.brand-text {
  font-size: 24px;
  font-weight: 700;
  color: white;
  letter-spacing: 1px;
}

/* 移动端菜单按钮 */
.mobile-menu-btn {
  display: none;
  flex-direction: column;
  justify-content: space-around;
  width: 30px;
  height: 30px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
}

.mobile-menu-btn span {
  width: 100%;
  height: 3px;
  background: white;
  border-radius: 2px;
  transition: all 0.3s ease;
}

.mobile-menu-btn.active span:nth-child(1) {
  transform: rotate(45deg) translate(8px, 8px);
}

.mobile-menu-btn.active span:nth-child(2) {
  opacity: 0;
}

.mobile-menu-btn.active span:nth-child(3) {
  transform: rotate(-45deg) translate(7px, -6px);
}

/* 导航菜单 */
.navbar-menu {
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 1;
}

.nav-links {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 4px;
  flex-wrap: wrap;
  flex: 1;
}

.nav-item {
  position: relative;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 12px;
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  border-radius: 8px;
  font-weight: 500;
  font-size: 13px;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  min-width: fit-content;
}

.nav-link::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s ease;
}

.nav-link:hover::before {
  left: 100%;
}

.nav-link:hover {
  background: rgba(255, 255, 255, 0.15);
  color: white;
  transform: translateY(-2px);
}

.nav-link.active {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.nav-link i {
  font-size: 16px;
  font-style: normal;
}

/* 用户菜单 */
.user-menu {
  position: relative;
  flex-shrink: 0;
}

.user-dropdown {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.user-dropdown:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
}

.user-avatar {
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

.user-name {
  color: white;
  font-weight: 500;
  font-size: 14px;
}

.dropdown-arrow {
  color: rgba(255, 255, 255, 0.7);
  font-size: 10px;
  transition: transform 0.3s ease;
  font-style: normal;
}

.user-dropdown.active .dropdown-arrow {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s ease;
  min-width: 160px;
  overflow: hidden;
}

.dropdown-menu.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  color: #333;
  text-decoration: none;
  transition: background-color 0.2s ease;
  cursor: pointer;
  font-size: 14px;
}

.dropdown-item:hover {
  background: #f8f9fa;
}

.logout-icon {
  font-size: 16px;
  font-style: normal;
}

/* 主内容区域 */
.main-content {
  min-height: calc(100vh - 140px);
  padding-top: 20px;
}

/* 页脚 */
footer {
  margin-top: 40px;
  padding: 20px 0;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  color: #6c757d;
  font-size: 14px;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .nav-links {
    gap: 2px;
  }
  
  .nav-link {
    padding: 8px 10px;
    font-size: 12px;
    gap: 4px;
  }
}

@media (max-width: 992px) {
  .navbar-container {
    padding: 0 10px;
  }
  
  .nav-links {
    gap: 1px;
  }
  
  .nav-link {
    padding: 8px 8px;
    font-size: 11px;
  }
  
  .brand-text {
    font-size: 20px;
  }
}

@media (max-width: 768px) {
  .navbar-container {
    padding: 0 15px;
  }

  .mobile-menu-btn {
    display: flex;
  }

  .navbar-menu {
    position: fixed;
    top: 70px;
    left: 0;
    right: 0;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    flex-direction: column;
    padding: 20px;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    height: calc(100vh - 70px);
    overflow-y: auto;
  }

  .navbar-menu.active {
    transform: translateX(0);
  }

  .nav-links {
    flex-direction: column;
    width: 100%;
    gap: 12px;
  }

  .nav-link {
    width: 100%;
    justify-content: flex-start;
    padding: 16px 20px;
    font-size: 16px;
  }

  .user-menu {
    width: 100%;
    margin-top: 20px;
  }

  .user-dropdown {
    width: 100%;
    justify-content: center;
    padding: 16px;
  }

  .dropdown-menu {
    position: static;
    opacity: 1;
    visibility: visible;
    transform: none;
    margin-top: 12px;
    box-shadow: none;
    background: rgba(255, 255, 255, 0.1);
  }

  .dropdown-item {
    color: white;
    justify-content: center;
  }

  .dropdown-item:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  .brand-text {
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  .navbar-container {
    height: 60px;
  }

  .brand-text {
    font-size: 18px;
  }

  .brand-icon {
    width: 35px;
    height: 35px;
    font-size: 18px;
  }

  .navbar-menu {
    top: 60px;
    height: calc(100vh - 60px);
  }
}

/* 动画效果 */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.nav-item {
  animation: slideIn 0.3s ease forwards;
}

.nav-item:nth-child(1) { animation-delay: 0.1s; }
.nav-item:nth-child(2) { animation-delay: 0.2s; }
.nav-item:nth-child(3) { animation-delay: 0.3s; }
.nav-item:nth-child(4) { animation-delay: 0.4s; }
.nav-item:nth-child(5) { animation-delay: 0.5s; }
.nav-item:nth-child(6) { animation-delay: 0.6s; }
.nav-item:nth-child(7) { animation-delay: 0.7s; }
.nav-item:nth-child(8) { animation-delay: 0.8s; }
.nav-item:nth-child(9) { animation-delay: 0.9s; }
</style>
